import React, { useEffect, useState } from "react";
import SignIn from "../../Components/SignInFlow/SignIn/SignIn";
import AuthLeftSection, { handleDownloadGoogleAppClick, handleDownloadAppleAppClick } from "../../Components/Shared/AuthLeftSection/AuthLeftSection";
import { useDispatch, useSelector } from "react-redux";
import ForgetPassword from "../../Components/SignInFlow/ForgetPassword/ForgetPassword";
import OtpVerification from "../../Components/SignInFlow/OtpVerification/OtpVerification";
import NewPassword from "../../Components/SignInFlow/Newpassword/NewPassword";
import PasswordChanged from "../../Components/SignInFlow/PasswordChanged/PasswordChanged";
import { setActiveComponent } from "../../Redux/Slices/activeComponentSlice";
import { getToken, getUserId } from "../../api/index";
import { useLocation, useNavigate } from "react-router-dom";
import EnterMobileNumber from "../../Components/SignInFlow/EnterMobileNumber/EnterMobileNumber";
import { getRedirectPath, storeRedirectPath, clearRedirectPath } from "../../utils/authRedirect";
const VALID_SIGN_IN_COMPONENTS = [
    "signIn",
    "signInEnterMobileNumber",
    "forgetPassword",
    "otpVerification",
    "newPassword",
    "passwordChanged"
];

const SignInPage = () => {

    const dispatch = useDispatch();
    const activeComponent = useSelector((state) => state.activeComponent.activeComponent);
    const navigate = useNavigate();
    const location = useLocation();
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        storeRedirectPath();
        if(getToken() && getUserId()){
            const target = getRedirectPath();
            clearRedirectPath();
            navigate(target, { replace: true });
        }
    }, [navigate]);

    useEffect(() => {
        if (!activeComponent || !VALID_SIGN_IN_COMPONENTS.includes(activeComponent) || activeComponent === "getStarted" || activeComponent === "enterMobileNumber") {
            dispatch(setActiveComponent("signIn"));
        }
    }, [location.key, location.pathname, activeComponent, dispatch]);

    useEffect(() => {
        const checkIsMobile = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        checkIsMobile();
        window.addEventListener('resize', checkIsMobile);

        return () => {
            window.removeEventListener('resize', checkIsMobile);
        };
    }, []);

    // const handleBackClick = () => {
    //     if (activeComponent === "forgetPassword") {
    //         dispatch(setActiveComponent("signIn"));
    //     }
    //     else if (activeComponent === "otpVerification") {
    //         dispatch(setActiveComponent("forgetPassword"));
    //     }
    //     else if (activeComponent === "newPassword") {
    //         dispatch(setActiveComponent("otpVerification"));
    //     }
    //     else if (activeComponent === "passwordChanged") {
    //         dispatch(setActiveComponent("newPassword"));
    //     }
    //     else if (activeComponent === "signInEnterMobileNumber") {
    //         dispatch(setActiveComponent("signIn"));
    //     }

    // }
    
    return (
        <div className="LandingPage">
            <div className="landingPageContainer">
                <AuthLeftSection />
                <div className="landingRightSection">
                    {/* {activeComponent !== "signIn" && activeComponent !== "passwordChanged" && (
                        <span className="backBtnContainer" onClick={handleBackClick}>
                            <img
                                src="/Assets/LandingPage/backArrow.svg"
                                alt="no img found"
                                className="backBtnIcon"
                            />
                            <span className="backBtnText">Back</span>
                        </span>
                    )} */}
                    
                    {/* Mobile Logo at top */}
                    {isMobile && (
                        <div 
                            className="mobileLogoContainer" 
                            onClick={() => navigate('/')} 
                            style={{ cursor: 'pointer' }}
                            title="Return to Amalgamate Home"
                        >
                            <img
                                className="mobileAmalgamateLogo"
                                src="/Assets/LandingPage/AmalgamateLogo.svg"
                                alt="Amalgamate Logo"
                            />
                        </div>
                    )}
                    
                    <div className="landingRightSectionContainer">
                        {
                            (!activeComponent || 
                             activeComponent === "signIn" || 
                             activeComponent === "getStarted" || 
                             activeComponent === "enterMobileNumber" || 
                             !VALID_SIGN_IN_COMPONENTS.includes(activeComponent)) && (
                                <SignIn />
                            )
                        }
                        
                        {
                            activeComponent === "signInEnterMobileNumber" && (
                                <EnterMobileNumber />
                            )
                        }
                        {
                            activeComponent === "forgetPassword" && (
                                <ForgetPassword />
                            )
                        }
                        {
                            activeComponent === "otpVerification" && (
                                <OtpVerification />
                            )
                        }
                        {
                            activeComponent === "newPassword" && (
                                <NewPassword />
                            )
                        }
                        {
                            activeComponent === "passwordChanged" && (
                                <PasswordChanged />
                            )
                        }
                    </div>
                    
                    {/* Mobile Download Cards at bottom */}
                    {isMobile && (
                        <div className="mobileDownloadSection">
                            <div className="mobileGetTheAppContainer">
                                <div className="mobileFadingLine1"></div>
                                <span className="mobileGetTheAppText">Get The App</span>
                                <div className="mobileFadingLine2"></div>
                            </div>
                            <div className="mobileDownloadAppCards">
                                <div className="mobileDownloadAppCardContainer">
                                    <div className="mobileDownloadAppCard" onClick={handleDownloadGoogleAppClick}>
                                        <img
                                            src="/Assets/LandingPage/playStoreIcon.svg"
                                            alt="no img found"
                                            className="mobileDownloadAppCardIcon"
                                        />
                                        <div className="mobileDownloadAppCardTextContainer">
                                            <span className="mobileDownloadAppCardText1">Get it on</span>
                                            <span className="mobileDownloadAppCardText2">
                                                Google Play
                                            </span>
                                        </div>
                                    </div>
                                    <div className="mobileDownloadAppCard" onClick={handleDownloadAppleAppClick}>
                                        <img
                                            src="/Assets/LandingPage/appStoreIcon.svg"
                                            alt="no img found"
                                            className="mobileDownloadAppCardIcon2"
                                        />
                                        <div className="mobileDownloadAppCardTextContainer">
                                            <span className="mobileDownloadAppCardText1">
                                                Get it on
                                            </span>
                                            <span className="mobileDownloadAppCardText2">App Store</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
};

export default SignInPage;

